module.exports = __webpack_public_path__ + "img/icons8_feedly_1.8c60cd5b.svg";